import { formatAmountShort } from "@portal/util/number-formatter";
import { Col, Row } from "../Grid/AntGrid";
import { TypographyText } from "../Typography/AntTypography";
import { InvoiceOptions } from "./type";

function InvoicesOptions(props: InvoiceOptions) {
  const { label, details } = props;

  const Label = <TypographyText fs="14">{label}</TypographyText>;
  const Amount = (
    <TypographyText fs="14">
      {formatAmountShort(details.amount, details.currency)}
    </TypographyText>
  );
  return (
    <Row gutter={[24, 24]}>
      <Col flex={100}>{Label}</Col>
      <Col flex="auto"> {Amount}</Col>
    </Row>
  );
}

export { InvoicesOptions };
